import { render } from "./Header.vue?vue&type=template&id=6af58afa&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6af58afa&scoped=true&lang=css"

import exportComponent from "/Users/bilawal/Sites/bizrar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af58afa"]])

export default __exports__